import styled from '@emotion/styled'
import { Row } from 'react-bootstrap'

export const DualValueCurrencyRow = styled(Row)`
  label: DualValueCurrencyRow;
  diplay: flex;
  flex-wrap: nowrap;
  margin-top: 6px;
  margin-right: -15px;
  margin-left: -15px;
  box-sizing: border-box;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const DualValueCurrencyTextDiv = styled.div`
  label: DualValueCurrencyTextDiv;
  margin-left: 1rem;
  text-align: left;
  flex-grow: 1;
  max-width: 65%;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
`

export const DualValueCurrencyValuesDiv = styled.div`
  label: DualValueCurrencyValuesDiv;
  display: flex;
  justify-content: space-between;
  padding-left: 18px;
  padding-right: 18px;
`

export const DualValueCurrencyValueDiv = styled.div`
  label: DualValueCurrencyValueDiv;
  width: 100px;
  overflow-wrap: break-word;
  text-align: right;
`
